module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_6005.a461684d.png";